import FadeIn from "@/components/FadeIn";

const CHAPTERS = [
  {
    num: "01",
    title: "L'hyper-donnée locale",
    text: "Chaque rue de Paris, chaque commune d'Île-de-France a sa cote. Notre moteur lit les transactions réelles DVF autour de votre adresse — pas des moyennes de quartier, mais des ventes signées, géolocalisées, récentes.",
  },
  {
    num: "02",
    title: "Données & transparence",
    text: "Votre estimation s'appuie sur les Demandes de Valeurs Foncières, les indicateurs des notaires et des comparables récents. Chaque rapport cite ses sources, sa date et son périmètre — rien n'est laissé au hasard.",
  },
  {
    num: "03",
    title: "Discrétion & sur-mesure",
    text: "Vente uniquement, prestations de prestige. Chaque demande est relue par un conseiller dédié qui connaît votre secteur, et c'est lui — et lui seul — qui vous recontacte, avec votre accord.",
  },
];

export default function ManifestoSection() {
  return (
    <section id="manifeste" data-testid="manifesto-section" className="mx-auto max-w-7xl px-6 py-24 lg:py-32">
      <FadeIn>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37]/80">Le manifeste</p>
        <h2 className="font-display mt-4 max-w-2xl text-2xl font-normal tracking-tight text-amber-100 sm:text-3xl lg:text-4xl">
          Trois engagements, une seule exigence : <em className="text-[#D4AF37]">l'excellence.</em>
        </h2>
      </FadeIn>
      <div className="mt-16 space-y-0">
        {CHAPTERS.map((c, i) => (
          <FadeIn key={c.num} delay={i * 0.1}>
            <div
              data-testid={`manifesto-chapter-${c.num}`}
              className="group grid grid-cols-1 gap-6 border-t border-stone-800/80 py-12 transition-colors duration-500 hover:border-[#D4AF37]/30 md:grid-cols-12"
            >
              <div className="md:col-span-3">
                <span className="outline-number font-display text-7xl font-light lg:text-8xl">{c.num}</span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display text-xl font-medium text-amber-200/90 sm:text-2xl">{c.title}</h3>
              </div>
              <div className="md:col-span-5">
                <p className="text-base leading-relaxed text-stone-400">{c.text}</p>
              </div>
            </div>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}
